import React from "react";
import { Link, useLocation } from "react-router-dom";

import { setCartItems } from "@redux/cart/slice";
import { rerender } from "@redux/rerender/slice";
import { useAppDispatch, useAppSelector } from "@redux/store";
import { ITotalCartItems } from "@redux/cart/types";
import { getCartItemsFromStorage } from "@/utils";

import cartEmptyIcon from "@/assets/icons/cartEmpty.svg";
import cartFullIcon from "@/assets/icons/cartFull.svg";

import styles from "./CartIcon.module.scss";

export const CartIcon: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const { totalCartItems } = useAppSelector(state => state.cart);

  React.useEffect(() => {
    const storageCartItems = getCartItemsFromStorage();
    if (storageCartItems) dispatch(setCartItems(storageCartItems));
  }, []);

  const isCartEmpty = testCartEmpty(totalCartItems);

  function testCartEmpty(cartItems: ITotalCartItems) {
    return !!(
      Object.keys(cartItems.rackets || {}).length ||
      Object.keys(cartItems.seats || {}).length
    );
  }

  const handleClick = () => {
    const currentPath = location.pathname;
    if (currentPath === "/cart") {
      dispatch(rerender());
    }
  };

  return (
    <div className={styles.icons__cart}>
      <Link to="/cart" onClick={handleClick} state={{ from: location.pathname }}>
        {
          !isCartEmpty
            ? (
              <img src={cartEmptyIcon} alt="cart empty icon" />
            ) : (
              <img src={cartFullIcon} alt="cart full icon" />
            )
        }
        <span>
          Корзина
        </span>
      </Link>
    </div>
  );
};
